import {compact} from "lodash-es";

export function combineClassnames(...classes: unknown[]): string {
    return compact(classes).filter(Boolean).join(' ');
}